import Api from 'libs/api';

class UserApi extends Api {
  constructor() {
    super('users');
  }
}

export default UserApi;
